/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Forward_Ten_FramesInputs */



/**
* | output |
* | --- |
* | "Go forward ten frames in the video" |
*
* @param {Shortcut_Keys_Desc_Forward_Ten_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_forward_ten_frames = /** @type {((inputs?: Shortcut_Keys_Desc_Forward_Ten_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Forward_Ten_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avancer de dix images dans la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spulen Sie im Video zehn Bilder vor.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai avanti di dieci fotogrammi nel video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перемотайте видео на десять кадров вперед.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avanzar diez fotogramas en el vídeo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频快进十帧。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオを10フレーム進める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में दस फ्रेम आगे बढ़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avance dez quadros no vídeo.")
	return /** @type {LocalizedString} */ ("Go forward ten frames in the video")
});